export type AppLocale = 'pt-BR' | 'en' | 'es-ES';

export const LOCALE_STORAGE_KEY = 'fisital_locale';

export const DEFAULT_LOCALE: AppLocale = 'pt-BR';

export interface LocaleOption {
  id: AppLocale;
  label: string;
  shortLabel: string;
  flag: string;
}

export const SUPPORTED_LOCALES: readonly LocaleOption[] = [
  { id: 'pt-BR', label: 'Português (Brasil)', shortLabel: 'BR', flag: '🇧🇷' },
  { id: 'en', label: 'English', shortLabel: 'EN', flag: '🇺🇸' },
  { id: 'es-ES', label: 'Español (España)', shortLabel: 'ES', flag: '🇪🇸' },
];

export type TranslationParams = Record<string, string | number>;

export interface TranslationTree {
  [key: string]: string | TranslationTree;
}
